/**
 * Key Pair Connector Component
 * Form component for key pair authentication configuration
 */

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import type { UseFormReturn } from 'react-hook-form'

interface KeyPairConnectorProps {
  form: UseFormReturn<any>
}

/**
 * Key Pair connector form component
 */
export function KeyPairConnector({ form }: KeyPairConnectorProps) {
  return (
    <>
      <FormField
        control={form.control}
        name="publicKey"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Public Key</FormLabel>
            <FormMessage />
            <FormControl>
              <Input
                value={field.value ?? ""}
                placeholder="Add key"
                {...form.register("publicKey", {
                  required: true,
                })}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="privateKey"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Private/Secret Key</FormLabel>
            <FormMessage />
            <FormControl>
              <Input
                value={field.value ?? ""}
                placeholder="Add key"
                {...form.register("privateKey", {
                  required: true,
                })}
              />
            </FormControl>
          </FormItem>
        )}
      />
    </>
  )
}